import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PlatformService } from '../../services/platform.service';
import basePath from '../../utils/basePath';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
    constructor(private platformService: PlatformService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let newRequest: HttpRequest<unknown>;
        if (request.headers.get('x-is-static-file')) {
            const baseHost = this.platformService.isServer()
                ? environment.serverHost
                : location.origin;
            newRequest = request.clone({
                url: `${baseHost}${basePath(request.url)}`
            });
        } else {
            const baseHost = this.platformService.isServer()
                ? environment.apiHost
                : location.origin;
            newRequest = request.clone({
                url: `${baseHost}${request.url}`
            });
        }
        return next.handle(newRequest);
    }
}
